/*
 * Purpose: AutoBlocks compose page — Mission/Flow continuation from home
 * Last modified: 2026-06-27 | Agent
 * Completeness: 92
 */
import { useNavigate } from 'react-router-dom';
import { PRODUCT_TERMS } from '@/lib/productTerms';
import { SetupBanner } from '@/components/setup/SetupBanner';
import { AutoBlocksComposer } from '@/components/AutoBlocksComposer';
import { ArtifactStateBadge } from '@/components/intent/ArtifactStateBadge';
import { useAutoBlocksStore } from '@/stores/autoBlocksStore';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Wand2 } from 'lucide-react';
import { BrandMark } from '@/components/brand/BrandMark';
import { PageMotion } from '@/components/motion/PageMotion';

export default function ComposePage() {
  const navigate = useNavigate();
  const artifactState = useAutoBlocksStore((s) => s.artifactState);
  const composeMode = useAutoBlocksStore((s) => s.composeMode);
  const phase = useAutoBlocksStore((s) => s.phase);

  const subtitle =
    artifactState === 'flow'
      ? 'Your Flow is ready — open Builder to edit the map'
      : phase === 'confirm'
        ? 'Confirm interpretation — Express or Guided'
        : 'Running = Mission · At rest = Flow';

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="shrink-0 border-b px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <BrandMark size={24} className="shrink-0" ghostAccent="darker" />
          <div className="min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <h1 className="ab-brand-wordmark text-foreground truncate text-base sm:text-lg">
                {PRODUCT_TERMS.autoBlockFlowComposer}
              </h1>
              <ArtifactStateBadge artifactState={artifactState} composeMode={composeMode} />
            </div>
            <p className="text-xs text-muted-foreground truncate">{subtitle}</p>
          </div>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" className="hidden sm:inline-flex" onClick={() => navigate('/setup')}>
            <Wand2 className="h-4 w-4 mr-1" />
            Onboarding
          </Button>
          <Button variant="ghost" size="sm" onClick={() => navigate('/')}>
            <ArrowLeft className="h-4 w-4 mr-1" />
            Home
          </Button>
          <Button variant="outline" size="sm" onClick={() => navigate('/builder')}>
            Builder
          </Button>
        </div>
      </header>
      <SetupBanner />
      <main className="flex-1 overflow-auto p-4 sm:p-6">
        <PageMotion>
          <AutoBlocksComposer />
        </PageMotion>
      </main>
    </div>
  );
}
